import { Button, ButtonProps } from "@chakra-ui/button";
import React, { forwardRef, memo } from "react";

const GamelightButton = memo(
  forwardRef((props: ButtonProps, ref: React.Ref<HTMLButtonElement>) => {
    const { colorScheme } = props;

    return (
      <Button
        ref={ref}
        colorScheme={colorScheme || "brand"}
        borderRadius={8}
        {...props}
      >
        {props.children}
      </Button>
    );
  })
);

export default GamelightButton;
